import { render, staticRenderFns } from "./NewsOverviewComponent.vue?vue&type=template&id=55d4ab59&scoped=true&"
import script from "./NewsOverviewComponent.vue?vue&type=script&lang=ts&"
export * from "./NewsOverviewComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d4ab59",
  null
  
)

export default component.exports